// 切换输入法——主流程
const MainRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `input/index${i + 1}`,
  name: `inputIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/input/index${i + 1}.vue`)
}))



export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 切换输入法——主流程，开始
    ...MainRoutes,

  ],
};
